
import React from 'react';

export const HeroSection: React.FC = () => {
  return (
    <section 
      className="relative bg-cover bg-center bg-no-repeat py-24 lg:py-32"
      style={{
        backgroundImage: `linear-gradient(rgba(0, 0, 0, 0.6), rgba(0, 0, 0, 0.6)), url('https://public.readdy.ai/ai/img_res/a9c4e842e6d0e95fb46c809b5423d0c5.jpg')`
      }}
    >
      <div className="max-w-7xl mx-auto px-6 text-center">
        <div className="max-w-4xl mx-auto">
          <h1 className="text-4xl lg:text-6xl font-bold text-white mb-6">
            Build Your Career with 
            <span className="block text-blue-400">Business Development Authority</span>
          </h1>
          <p className="text-xl lg:text-2xl text-gray-200 mb-8 leading-relaxed">
            Join our dynamic team of industry experts and shape the future of business development, AI consulting, and strategic growth initiatives across multiple authority domains.
          </p>
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <button 
              onClick={() => document.getElementById('open-positions')?.scrollIntoView({ behavior: 'smooth' })}
              className="bg-blue-600 text-white px-8 py-4 rounded-lg font-semibold hover:bg-blue-700 transition-colors cursor-pointer whitespace-nowrap"
            >
              View Open Positions
            </button>
            <button 
              onClick={() => document.getElementById('culture')?.scrollIntoView({ behavior: 'smooth' })}
              className="border-2 border-white text-white px-8 py-4 rounded-lg font-semibold hover:bg-white hover:text-gray-900 transition-colors cursor-pointer whitespace-nowrap"
            >
              Our Culture
            </button>
          </div>
        </div>
      </div>
    </section>
  );
};
